/* eslint-disable import/no-cycle */
import React from 'react';
import { WrappedFunctionProps } from '../types';
import { ImageField as FormImageField } from '../../apiForm/form/input';

export default function ImageField({
  inputKey,
  translation,
  language,
  control,
}: WrappedFunctionProps) {
  return (
    <FormImageField
      control={control}
      name={inputKey}
      label={translation?.title?.[language] || inputKey}
    />
  );
}
